export default __webpack_public_path__ + "static/media/BannerSmartyPantsPanda.9f022081.png";